import { sanitizeHtml } from '../../../lib/sanitizeHtml';

// Renderiza el campo "Valor" de una Secuencia, que ahora puede traer HTML enriquecido
// (negrita, color, alineación) escrito desde el RichTextEditor del admin. El contenido
// viejo en texto plano se muestra igual que antes: sin tags, sanitizeHtml no le hace nada.
export default function SafeHtml({ html, className, style, as = 'div' }) {
  if (!html) return null;
  const Tag = as;
  return <Tag className={className} style={style} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}
